import { useQuery } from '@tanstack/react-query';
import { type ApprovedSet, loadApproved } from '../storage/approvedVerificationStorage';
const EMPTY: ApprovedSet = {
  approvedBios: [],
  approvedAvatars: []
};

// Returns null while loading. Invalidate approvedSetQueryKey(userId) after any write.
export const approvedSetQueryKey = (userId: number) => ['verification.approvedSet', userId] as const;
export function useApprovedSet(userId: number): ApprovedSet | null {
  const {
    data
  } = useQuery({
    queryKey: approvedSetQueryKey(userId),
    queryFn: async () => {
      try {
        return (await loadApproved(userId)) ?? EMPTY;
      } catch {
        return EMPTY;
      }
    },
    staleTime: Infinity
  });
  return data ?? null;
}